/**
 * Error thrown when a feature item value cannot be normalized for the given valueType.
 */
export class FeatureItemValueNormalizeError extends Error {
  constructor(message: string) {
    super(message);
    this.name = 'FeatureItemValueNormalizeError';
  }
}
